export type TWindow = Window & typeof globalThis;
